<template>
  <div class="body-wrapper">
    <Header :title="getTitle()" />
    <div class="modal-body">
      <div class="modal-row" v-if="creating || challengeCategory == 'weight'">
        <div class="modal-input">
          <label>Title:</label>
          <input 
            v-model="challengeName"
            :class="{'error': challengeNameError}"
            type="text" 
            class="title" 
            placeholder="Title"/>
        </div>
      </div>

      <div class="modal-row" v-if="challengeCategory == 'weight' || challengeCategory == 'exercise'">
        <div class="modal-input">
          <label>Category:</label>
          <select 
            :disabled="!creating"
            v-model="challengeCategory"
            :class="{'error': challengeCategoryError}">
              <option value="" disabled>Select category</option>
              <option value="weight">Weight Lifted</option>
              <option value="exercise">Exercise Completed</option>
          </select>
        </div>
        <div class="modal-input" v-if="challengeCategory == 'weight'">
          <label>Weight Requirement KG:</label>
          <input 
            v-model="challengeWeight"
            :class="{'error': challengeWeightError}"
            type="text" 
            class="title" 
            placeholder="Title"/>
        </div>
        <div class="modal-input exercise-search" v-else>
          <label>Exercise:</label>
          <div class="search-box">
            <input 
              :disabled="!creating"
              type="text" v-model="exerciseSearch" @keyup="searchForExercise()" @focus="resultVisible = true;">
            <div class="results" v-if="resultVisible">
              <p 
                v-bind:key="exercise.id"
                @click="addExercise(exercise)"
                v-for="exercise in exercisesResponse">{{exercise.title}} - {{exercise.equipment}}</p>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-row">
        <div class="modal-input">
          <label>Description:</label>
          <textarea
            v-model="challengeDescription"
            placeholder="Use {number}, {month} and {year} to insert dynamic values."
            :class="{'error': challengeDescriptionError}"/>
        </div>
      </div>

      <div class="modal-row" v-if="!creating">
        <div class="image-input">
          <label>Badge Image:</label>

          <div class="picture-row" v-for="(level, index) in levels" :key="index">
            <div class="picture-holder">
              <div class="picture-box">
                <form enctype="multipart/form-data" novalidate>
                  <div class="dropbox default">
                    <input
                      type="file"
                      @change="
                        filesChange($event.target.files, index);
                        fileCount = $event.target.files.length;
                      "
                      accept="image/*"
                      class="input-file"
                    />
                    <img class="default-img" v-if="level.previewUrl == ''" id="preview" src="../assets/add_photo_grey.png" />
                    <img v-if="level.previewUrl != ''" id="preview" :src="level.previewUrl" />
                  </div>
                </form>
              </div>
            </div>
            <div class="picture-details" v-if="challengeCategory != 'exercise' && challengeCategory != 'weight' && challengeCategory != 'repeats'">
              <label>Title:</label>
              <input type="text" class="" placeholder="0" v-model="level.title"/>
            </div>
            <div class="picture-details" v-if="challengeCategory == 'exercise'">
              <label>Workouts required:</label>
              <input type="text" class="" placeholder="0" v-model="level.workoutsRequired"/>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-row" v-else-if="challengeCategory == 'weight'">
        <div class="image-input">
          <label>Badge Image:</label>
          <div class="picture-holder">
            <div class="picture-box">
              <form enctype="multipart/form-data" novalidate>
                <div class="dropbox default">
                  <input
                    type="file"
                    @change="
                      filesChange($event.target.files, 0);
                      fileCount = $event.target.files.length;
                    "
                    accept="image/*"
                    class="input-file"
                  />
                  <img class="default-img" v-if="levels[0].previewUrl == '' && currentImage == ''" id="preview" src="../assets/add_photo_grey.png" />
                  <img v-if="levels[0].previewUrl != ''" id="preview" :src="levels[0].previewUrl" />
                  <img v-else-if="currentImage != ''" id="preview" :src="currentImage" />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-row" v-else>
        <div class="image-input">
          <label>Badge Image:</label>

          <div class="picture-row" v-for="i in [1,2,3,4,5]" :key="i">
            <div class="picture-holder">
              <div class="picture-box">
                <form enctype="multipart/form-data" novalidate>
                  <div class="dropbox default">
                    <input
                      type="file"
                      @change="
                        filesChange($event.target.files, i - 1);
                        fileCount = $event.target.files.length;
                      "
                      accept="image/*"
                      class="input-file"
                    />
                    <img class="default-img" v-if="levels[i - 1].previewUrl == ''" id="preview" src="../assets/add_photo_grey.png" />
                    <img v-if="levels[i - 1].previewUrl != ''" id="preview" :src="levels[i - 1].previewUrl" />
                  </div>
                </form>
              </div>
            </div>
            <div class="picture-details">
              <label>Level {{i}} Workouts Required:</label>
              <input type="text" class="" placeholder="0" v-model="levels[i - 1].workoutsRequired"/>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-row">
        <div class="modal-input">
          <label>Hidden from Explore:</label>
          <ToggleButton :value="challengeHiddenFromExplore" color="#066DCD"/>
        </div>
      </div>

      <div class="buttons">
        <button class="secondary-btn-dark" @click="cancelChanges();">
          DISCARD CHANGES
        </button>
        <button @click="saveChallenge()" class="primary-btn">
          {{ creating ? 'CREATE CHALLENGE' : 'SAVE CHANGES' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { isNumeric } from '@/utils'
import { createChallenge, getExercises, updateChallenge, getParentChallenge } from '@/api/requests';
import Header from "@/components/header/Header";
import { ToggleButton } from 'vue-js-toggle-button'
import { debounce } from "debounce";

export default {
  name: 'Challenges',

  components: {
    Header,
    ToggleButton,
  },

  mounted() {
    this.creating = this.$route.params.creating;

    if (this.$route.params.challenge) {
      this.loadChallengeDetails(this.$route.params.challenge.parent_challenge_id, this.$route.params.challenge.category);
      this.editChallengeId = this.$route.params.challenge.parent_challenge_id;
      this.challengeName = this.$route.params.challenge.title;
      this.challengeCategory = this.$route.params.challenge.category;
      this.challengeDescription = this.$route.params.challenge.description;
      this.currentImage = this.getChallengePicture(this.$route.params.challenge.image);
    }
  },

  data() {
    return {
      creating: false,
      editChallengeId: '',
      currentImage: '',
      challengeName: '',
      challengeNameError: false,
      challengeCategory: 'exercise',
      challengeCategoryError: false,
      challengeWeight: '',
      challengeWeightError: false,
      challengeExercise: '',
      challengeExerciseError: false,
      challengeDescription: '',
      challengeDescriptionError: false,
      challengeHiddenFromExplore: false,
      challengeImageError: false,
      levels: [
        {
          image: null,
          previewUrl: '',
          workoutsRequired: 0,
        },
        {
          image: null,
          previewUrl: '',
          workoutsRequired: 0,
        },
        {
          image: null,
          previewUrl: '',
          workoutsRequired: 0,
        },
        {
          image: null,
          previewUrl: '',
          workoutsRequired: 0,
        },
        {
          image: null,
          previewUrl: '',
          workoutsRequired: 0,
        },
      ],
      exerciseSearch: '',
      resultVisible: false,
      exercisesResponse: [],
    };
  },

  methods: {
    getTitle() {
      return this.creating ? 'CREATE: BADGE' : 'EDIT: BADGE';
    },

    filesChange(fileList, index) {
      this.levels[index].previewUrl = URL.createObjectURL(fileList[0]);
      this.levels[index].image = fileList[0];
    },

    getChallengePicture(image) {
      if (image !== "" && image !== null) {
        let url = window.location.origin;
        if (url === "http://localhost:8080") {
          url = "http://localhost:3000";
        }
        return url + image;
      }
      return "";
    },

    validateCreateChallenge() {
      let valid = true;
      this.challengeNameError = false;
      this.challengeCategoryError = false;
      this.challengeWeightError = false;
      this.challengeExerciseError = false;
      this.challengeDescriptionError = false;
      this.challengeImageError = false;
      
      if (this.challengeName == '') {
        valid = false;
        this.challengeNameError = true;
      }
      if (this.challengeCategory == '') {
        valid = false;
        this.challengeCategoryError = true;
      }
      if (this.challengeCategory == 'weight' && (this.challengeWeight == '' || isNumeric(this.challengeWeight) == false)) {
        valid = false;
        this.challengeWeightError = true;
      }
      if (this.challengeCategory == 'exercise' && this.challengeExercise == '') {
        valid = false;
        this.newExerciseEquipmentError = true;
      }
      if (this.challengeDescription == '') {
        valid = false;
        this.challengeDescriptionError = true;
      }
      if (this.levels[0].image == null) {
        valid = false;
        this.challengeImageError = true;
      }

      return valid;
    },

    validateUpdateChallenge() {
      let valid = true;
      this.challengeNameError = false;
      this.challengeDescriptionError = false;
      this.challengeImageError = false;
      
      if (this.challengeName == '') {
        valid = false;
        this.challengeNameError = true;
      }
      if (this.challengeDescription == '') {
        valid = false;
        this.challengeDescriptionError = true;
      }

      return valid;
    },

    createNewChallenge() {
      if (this.validateCreateChallenge()) {
        let payload = {
          title: this.challengeName,
          description: this.challengeDescription,
          category: this.challengeCategory,
          hidden_from_explore: this.challengeHiddenFromExplore,
          applicable_exercise_id_1: this.challengeExercise,
          applicable_value: this.challengeWeight,
        };

        let formData = new FormData();
        for (var key in payload) {
          formData.append(key, payload[key]);
        }

        if (this.challengeCategory == 'exercise') {
          for(let i = 0; i < this.levels.length; i++) {
            let currentLevel = this.levels[i];
            if (currentLevel.image == null || currentLevel.workoutsRequired == 0) {
              break;
            }

            formData.append(
              "image" + (i + 1),
              this.levels[i].image,
              this.levels[i].image.name
            );
            formData.append(
              "exercise_value_" + (i + 1),
              this.levels[i].workoutsRequired,
            )
          }
        } else {
          formData.append(
            "image1",
            this.levels[0].image,
            this.levels[0].image.name
          );
        }

        createChallenge(formData).then(() => {
          this.$toasted.global.app_success({
            message: "Challenge has been created."
          });
          this.$router.go(-1);
          this.$store.dispatch('reloadTable');
        });
      } else {
        this.$toasted.global.app_error({
          message: "Please fill in all required fields."
        });
      }
    },

    updateExistingChallenge() {
      if (this.validateUpdateChallenge()) {
        let payload = {
          title: this.challengeName,
          description: this.challengeDescription,
          category: this.challengeCategory,
          hidden_from_explore: this.challengeHiddenFromExplore,
        };

        if (this.challengeCategory == 'weight') {
          payload.applicable_value = this.challengeWeight;
        } else if (this.challengeCategory == 'exercise') {
          payload.applicable_exercise_id_1 = this.challengeExercise;
        }

        let formData = new FormData();
        for (var key in payload) {
          formData.append(key, payload[key]);
        }

        if (this.challengeCategory == 'exercise') {
          for(let i = 0; i < this.levels.length; i++) {
            if (this.levels[i].image != null) {
              formData.append(
                "image" + (i + 1),
                this.levels[i].image,
                this.levels[i].image.name
              );
            }
            formData.append(
              "exercise_value_" + (i + 1),
              this.levels[i].workoutsRequired,
            )
          }
        } else if (this.challengeCategory == 'weight') {
          if (this.levels[0].image != null) {
            formData.append(
              "image1",
              this.levels[0].image,
              this.levels[0].image.name
            );
          }
        } else {
          for(let i = 0; i < this.levels.length; i++) {
            if (this.levels[i].image != null) {
              formData.append(
                "image" + (i + 1),
                this.levels[i].image,
                this.levels[i].image.name
              );
            }
            formData.append(
              "title" + (i + 1),
              this.levels[i].title,
            )
          }
        }

        updateChallenge(this.editChallengeId, formData).then(() => {
          this.$toasted.global.app_success({
            message: "Challenge has been updated."
          });
          this.$router.go(-1);
          this.$store.dispatch('reloadTable');
        });
      } else {
        this.$toasted.global.app_error({
          message: "Please fill in all required fields."
        });
      }
    },

    saveChallenge() {
      if (this.creating) {
        this.createNewChallenge();
      } else {
        this.updateExistingChallenge();
      }
    },

    cancelChanges() {
      this.$router.go(-1);
    },

    searchForExercise: debounce(function (e) {
      const payload = {
        offset: 0,
        search: this.exerciseSearch,
        only_workouts: true,
        only_official: true,
      };

      getExercises(payload).then((response) => {
        this.exercisesResponse = response.data['exercises'];
      });
    }, 400),

    addExercise(ex) {
      this.resultVisible = false;
      this.exerciseSearch = ex.title + " - " + ex.equipment;
      this.challengeExercise = ex.id;
    },

    loadChallengeDetails(id, category) {
      getParentChallenge(id).then((data) => {
        this.levels = [];
        for (let i = 0; i  < data.data.levels.length; i++) {
          let level = data.data.levels[i];

          // Set description to unformatted description
          if (level.unformatted_description) {
            this.challengeDescription = level.unformatted_description;
          }

          // Get current weight value
          if (category == 'weight') {
            this.challengeWeight = level.criteria[0].applicable_value;
          }

          // Get current exercise value
          let value = null;
          if (category == 'exercise') {
            value = level.criteria[0].applicable_value;
          }

          this.levels.push({
            image: null,
            previewUrl: this.getChallengePicture(level.image),
            title: level.title,
            workoutsRequired: value,
          });
        }
      });
    }

  },

  computed: {

  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables";

.modal-body {
  padding: $spacing-base;

  .modal-row {
    display: flex;
    margin-bottom: $spacing-base;
    gap: $spacing-small;
    
    label {
      display: block;
      color: $sec7;
      font-size: $font-size-base;
      margin-bottom: 2px;
    }

    .modal-input {
      width: 100%;
      
      .title {
        width: 45%;
      }
      
      .keywords {
        height: 40px;
      }

      select {
        width: 100%;
      }

      textarea {
        width: 100%;
        box-sizing: border-box;
        resize: none;
      }

      ul {
        list-style: none;
        padding: 0;
        margin: 0;
        margin-top: 8px;

        li {
          background: $sec0;
          color: $sec5;
          float: left;
          font-size: $font-size-small;
          border-radius: 100px;
          padding: 2px 9px;
          justify-content: center;
          display: flex;
          align-items: center;
          margin-right: 4px;
          margin-bottom: 4px;

          i {
            padding: 3px;
            cursor: pointer;
          }
        }
      }
    }
  }
}

.picture-row {
  display: flex;
  flex-direction: row;

  .picture-details {
    margin-left: $spacing-base;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-bottom: 16px;
  }
}

.picture-holder {
  display: flex;
  margin-bottom: $spacing-base;

  .picture-box {
    width: 117px;
    height: 117px;
  }

  .dropbox { 
    width: 117px;
    height: 117px;
    background: $sec2;
    border: 1px solid $sec3;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 0;

    .default-img {
      width: 20px;
      height: 20px;
    }

    .display-img {
      width: 100%;
      border-radius: 0;
    }

    img {
      width: 117px;
      height: 117px;
      border-radius: 0;
    }
  }

  p {
    flex: 3;
    margin: 0;
    margin-left: $spacing-base/2;
    padding: 0;
    font-size: $font-size-small;
    color: $sec2;
  }
}

.buttons {
  width: 500px;

  .primary-btn {
    flex: 2;
  }

  .secondary-btn-dark {
    flex: 1;
  }
}

.exercise-search {
  .row {
    display: flex;
    justify-content: space-between;

    p {
      color: $sec5;
      font-weight: bold;
      font-size: 14px;
    }
  }

  .search-box {
    position: relative;
    margin-bottom: 12px;

    input {
      width: 100%;
      box-sizing: border-box;
      outline: 0;
    }
    .results {
      position: absolute;
      z-index: 1;
      background: $sec1;
      width: 100%;
      padding: 8px;
      box-sizing: border-box;

      p {
        margin: 0;
        font-size: 14px;
        color: $dark;
        cursor: pointer;
      }
      p:hover {
        opacity: 0.7;
      }
    }
  }
}
</style>
